import { PowerProfileDataPoint } from 'greener-ui-library';

interface PowerProfileStats {
  peakPower: number;
  averagePower: number;
  workingDays: string[];
  workingHoursStart: number;
  workingHoursEnd: number;
}

/**
 * Calculate statistics from power profile data
 * @param powerProfileData - Array of power profile data points
 * @returns Statistics including peak power, average power, working days and hours
 */
export const calculatePowerProfileStats = (powerProfileData?: PowerProfileDataPoint[]): PowerProfileStats => {
  // Default values when no data
  if (!powerProfileData || powerProfileData.length === 0) {
    return {
      peakPower: 0,
      averagePower: 0,
      workingDays: [],
      workingHoursStart: 8,
      workingHoursEnd: 17,
    };
  }

  // Calculate peak power
  const peakPower = Math.max(...powerProfileData.map((d) => d.power));

  // Calculate average power
  const averagePower = powerProfileData.reduce((sum, d) => sum + d.power, 0) / powerProfileData.length;

  // Extract working days (days with power usage above 50% of average)
  const workingDays = Array.from(
    new Set(powerProfileData.filter((d) => d.power > averagePower * 0.5).map((d) => d.day))
  );

  // Calculate working hours (when power is above 50% of average)
  const workingHoursData = powerProfileData.filter((d) => d.power > averagePower * 0.5);
  const workingHoursStart = workingHoursData.length > 0 ? Math.min(...workingHoursData.map((d) => d.hour)) : 8;
  const workingHoursEnd = workingHoursData.length > 0 ? Math.max(...workingHoursData.map((d) => d.hour)) : 17;

  return {
    peakPower,
    averagePower,
    workingDays,
    workingHoursStart,
    workingHoursEnd,
  };
};
